export default __webpack_public_path__ + "static/media/user_setup_bg.fffdbf41.png";